import { render, staticRenderFns } from "./BarChartComponent.vue?vue&type=template&id=b147516e"
import script from "./BarChartComponent.vue?vue&type=script&lang=js"
export * from "./BarChartComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports